export default "__VITE_PUBLIC_ASSET__22fca221__"